module.exports = __webpack_public_path__ + "img/ofszetnyomtatas-thumb.ffbe772f.jpg";